import { render, staticRenderFns } from "./AddressSubFieldsProperties.vue?vue&type=template&id=6a31d3f0"
import script from "./AddressSubFieldsProperties.vue?vue&type=script&lang=js"
export * from "./AddressSubFieldsProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports